import React from 'react';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import Modal from '../../../../Components/Modal/Modal';
import { Size } from '../../../../Enums/Size.enum';
import HealthPlanConfirm from './HealthPlanConfirm';
import { Flyer } from '../../../EArchive/Enums/Flyer.enum';

interface Props {
	title: string;
	text: string;
	imageSource: string;
	isOpen: boolean;
	onClose: () => void;
	patientId: string;
	flyerType: Flyer;
}
const HealthPlanCreateConfirmModal: React.FC<Props> = ({
	title,
	text,
	imageSource,
	isOpen,
	onClose,
	patientId,
	flyerType,
}) => {
	const { isCase } = useTreatmentContext();

	return (
		<Modal opened={isOpen} onClose={onClose} wrapChat={isCase} size={Size.MD}>
			<Modal.Header title={title} />
			<Modal.Content contentScroll>
				<HealthPlanConfirm
					patientId={patientId}
					text={text}
					imageSource={imageSource}
					flyerType={flyerType}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default HealthPlanCreateConfirmModal;
